import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl151ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    docPraktFileDate: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
    fudocPraktFile: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    d55_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    decisionText: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
  });
};
